import { time } from 'console';
import * as React from 'react';
import { Field } from '../dynamic-input-field/DynamicInputField';

import style from './TimePicker.module.css';

type TimePickerProps = {
    api: any,
    field: Field
}

const TimePicker = (props: TimePickerProps) => {
    props.field.custom = false;
    const dataStore = props.api.getDataStore(props.field);
    console.log('TimeSlot:', dataStore.get(props.field.name));

    const findCurrentWeek = () => {
        for (const [dateKey, dateValueU] of Object.entries(props.field.metadata)) {
            if (dateKey.toLocaleLowerCase() == 'status') { continue; }
            const dateValue = dateValueU as any;
            for (const [timeKey, timeValueU] of Object.entries(dateValue)) {
                const timeValue = timeValueU as any;
                if (dataStore.get(props.field.name) == timeValue.TimeSlotID) {
                    return dateKey
                }
            }
        }
        return '';
    };

    const defaultValue = findCurrentWeek();

    const [isValid, setValid] = React.useState(true);
    const [week, setWeek] = React.useState(defaultValue);

    const handleOnDateChange = (e: any) => {
        setWeek(e.target.value);
    }

    const handleOnTimeChange = (e: any) => {
        dataStore.put(props.field.name, e.target.value);
    }

    const validationStyling = isValid ? style.valid : style.invalid;

    props.field.validation = () => {
        if (!dataStore.get(props.field.name) || dataStore.get(props.field.name).trim().length == 0) {
            setValid(false);
            return false;
        }
        setValid(true);
        return true;
    }

    const dateSelection: any = [<option key='blank_field'></option>];
    for (const [key, value] of Object.entries(props.field.metadata)) {
        if (key.toLocaleLowerCase() == 'status') { continue; }
        dateSelection.push(
            <option key={key} value={key}>{key}</option>
        )
    }

    let timeSelection: any = [];
    if (week && props.field.metadata[week]) {
        timeSelection = props.field.metadata[week].map((field: any, index: number) => {
            return (
                <div key={field.TimeSlotID + '_' + field.Time + '_' + index} id={style.field}>
                    <input id={style.radio} type='radio' name='TimeSlot' value={field.TimeSlotID} defaultChecked={dataStore.get(props.field.name) == field.TimeSlotID}></input>
                    <label id={style.radioText}>{field.Time}</label>
                </div>
            )
        });
    }


    return <div id={style.container}>
        <div id={style.selectionContainer}>
            <select id={style.selection} className={validationStyling} onChange={handleOnDateChange} defaultValue={week}>
                {dateSelection}
            </select>
        </div>
        <div id={style.radioContainer} onChange={handleOnTimeChange}>
            {timeSelection}
        </div>
    </div>
};

export default TimePicker;